import React from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { FindADealerProps } from './types/findDealer.types';
import { FindADealerModel } from './models/findDealer.model';
import LocatorForm from './components/locatorForm';
import LazySection from '../@shared/lazySection';
import Picture from '../@shared/picture';
import { targetLinkdsk } from '../../utils/targetDskLink';
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import useEEActive from '../../hooks/useEEActive';
import CTAButton, { ctaEnums } from '../@shared/ctaButton';
import RoutableSitecoreLink from '../@shared/routableSitecoreLink';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const FindDealer = (props: FindADealerProps): JSX.Element => {
  const model = new FindADealerModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
  const isEE = useEEActive();
  const hasLocatorFunctionality = false;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }
  return (
    <LazySection>
      <div className="find-dealer">
        <div className="find-dealer-wrapper">
          <div className="find-dealer__bg-image-wrapper">
            <Picture
              editorialImageProps={{
                id: model.id,
                desktopImage: model.backgroundImage,
                mobileImage: model.mobileBackgroundImage,
                desktopTransformation: 'Size1900',
                mobileTransformation: 'Size1000',
                cssClassImageEl: 'find-dealer__bg-image',
              }}
            />
          </div>
          <div className="find-dealer__container">
            {model.title && (
              <Text field={model.title} className="find-dealer__text find-dealer__text--title is-title" tag={model.headingTag} />
            )}
            {model.content && <RichText field={model.content} className="find-dealer__content rich-text" />}
            {hasLocatorFunctionality ? (
              <LocatorForm model={model} />
            ) : (
              (isEE || (model.searchButtonText && model.searchUrl)) && (
                <CTAButton type={ctaEnums.primaryRed}>
                  <RoutableSitecoreLink field={model.searchButton} target={targetLinkdsk(model?.searchButton, isDesktop)} />
                </CTAButton>
              )
            )}
          </div>
        </div>
      </div>
    </LazySection>
  );
};

export default FindDealer;
